import StickySidebarPresenter from "../components/sticky-sidebar/presenter/sticky-sidebar.js";

const contentElement = document.querySelector(`.cart-order-summary`);

if (contentElement) {
  const stickySidebarComponent = new StickySidebarPresenter(contentElement, {
    minWidth: 1024
  });
  stickySidebarComponent.init();
}

